import { MessageTemplates } from '../sections/MessageTemplatesList/MessageTemplatesListTypes';

// TODO: can't use onDesktop as it is min-width:1024 and changing that at the moment might break other components.
export const isMobileChrome = () => (navigator.userAgent.match('CriOS')) && (window.matchMedia('(min-width: 768px)').matches) && (window.matchMedia('(max-width: 1024px)').matches);

export const haveMessageTemplate = (messageTemplates: MessageTemplates) => {
    return Boolean(messageTemplates && messageTemplates.pageInfo && messageTemplates.pageInfo.totalElements > 0);
};



// WEBPACK FOOTER //
// ./src/helpers/messenger.ts